<script setup>
import { useI18n } from "vue-i18n";
import { FormInput, FormCheckboxGroup, FormCheckboxGroupOption } from "@Components/Form";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const elements = [
    {
        key: "thumbnail",
        name: __("Image à la une"),
        description: __("Affiche l'image à la une de la publication."),
    },
    {
        key: "title",
        name: __("Titre"),
        description: __("Affiche le titre de la publication."),
    },
    {
        key: "excerpt",
        name: __("Extrait"),
        description: __("Affiche l'extrait de la publication."),
    },
];
</script>

<template>
    <div class="space-y-6">
        <FormCheckboxGroup :label="__('Elements à afficher')">
            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-1 2xl:grid-cols-3">
                <FormCheckboxGroupOption
                    v-for="element in elements"
                    :key="element.key"
                    v-model="modelValue.elements[element.key].enabled"
                    :title="element.name"
                    :description="element.description"
                />
            </div>
        </FormCheckboxGroup>

        <div class="max-w-sm">
            <FormInput
                v-if="modelValue.elements['excerpt'].enabled"
                :label="__('Longueur de l\'extrait')"
                v-model="modelValue.elements['excerpt'].length"
                type="number"
                min="0"
            />
        </div>
    </div>
</template>
